//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import React from 'react';
import styled from 'styled-components';

import LoadingShimmer from '@components/atoms/loading-shimmer/LoadingShimmer';

interface Props {
  className?: string;
}

/**
 * Renders 3 lines of the Loading Shimmer atom with standardized widths as a loading placeholder for captions
 */
export const LoadingShimmerCaption = ({ className = '' }: Props) => {
  return (
    <LoadingPlaceholderWrapper className={className}>
      <LinkMetadataShimmer width='80%' />
      <LinkMetadataShimmer width='90%' />
      <LinkMetadataShimmer width='80%' />
    </LoadingPlaceholderWrapper>
  );
};

const LinkMetadataShimmer = styled(LoadingShimmer).attrs({
  height: `${theme.spacings[2]}`,
})(
  ({ theme }) => `
    margin-bottom: ${theme.spacings[2]};

    &:last-of-type {
      margin-bottom: 0;
    }
`,
);

const LoadingPlaceholderWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`,
);

export default LoadingShimmerCaption;
